import React, { useState } from "react";
import styles from "./Cateringcartitemscard.module.css";
import veglabel from "../../assets/images/icon/veg.png";
import nonveglabel from "../../assets/images/non-vegetarian-sign-veg-logo-symbol-vector-50890043.jpg";
import breakfasticon from "../../assets/images/icon/breakfast.png";
import trashicon from "../../assets/images/icon/trashicon.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ShowDialogForPayment } from "../eventComponent/EventTabs/showdialogforpayment";

const CateringCartItemCard = ({
  eventId,
  eventname,
  data = [],
  serviceType = "cateringData",
  refreshCart,
  removeItem,
  openEditDialog,
  selectedcartitem,
  oncateringSelect,
  eventtitle,
  refundcateringfromcart,
  openRefundDialog,
}) => {
  const [editedItems, setEditedItems] = useState({});
  const [editingServices, setEditingServices] = useState({});
  // console.log("cateringdata",data)
  const [showDialog, setShowDialog] = React.useState(false);
  const handleRemove = async (providerId, mappingId) => {
    try {
      await removeItem(eventId, providerId, mappingId);
      refreshCart();
      window.scrollTo({ top: 0 });
    } catch (error) {
      console.error("Failed to remove catering item:", error);
    }
  };
  const selectedAmount = selectedcartitem
    .find((p) => p.eventid === eventId)
    ?.services["catering"]
    ?.find((pd) => pd.id === data[0].provider_id)?.total;

  const handleEditClick = (mappingId, service) => {
    setEditingServices((prev) => ({ ...prev, [mappingId]: true }));
    setEditedItems((prev) => ({
      ...prev,
      [mappingId]: {
        mapping_id: service.mapping_id,
        number_of_people: service.quantity,
        provider_id: service.provider_id,
        event_id: eventId,
      },
    }));
  };
  const { is_edit_allowed, paid_amount, is_checked_out, balance_to_be_paid,
    is_cancel_in_progress,
    is_canceled,

    refund_complete,
    refund_in_pending,
    refunded_amount,
  } = data[0];
  const { services } = data[0];
  const firstService = services?.[0] || {};
  const {
    total_amount,
    gst_percentage,
    gst_amount
  } = firstService;
  const handleCountChange = (mapping_id, value, provider_id) => {
    setEditedItems((prev) => ({
      ...prev,
      [mapping_id]: {
        ...prev[mapping_id],
        number_of_people: Math.max(0, parseInt(value) || 0),
        provider_id,
        event_id: eventId,
      },
    }));
  };
  const [showdeleteoverlay, setshowdeleteoverlay] = useState(false)
  const [showcancelationconfirmation, setshowcancelationconfirmation] = useState(false)
  const deletepaidamount = async () => {

    try {
      const response = await refundcateringfromcart(parseInt(eventId, 10),
        parseInt(data[0].provider_id, 10))
      setshowcancelationconfirmation(true);
      refreshCart();
      openRefundDialog(["catering"]);
    } catch (error) {

    }
    finally {
      setshowdeleteoverlay(false)
    }
  }
  const handleSave = async (providerId, mappingId) => {
    const updatedItem = editedItems[mappingId];
    if (!updatedItem) return;

    try {
      const result = await openEditDialog(eventId, providerId, [updatedItem]);
      if (result.success) {
        setEditingServices((prev) => ({ ...prev, [mappingId]: false }));
        setEditedItems((prev) => {
          const newItems = { ...prev };
          delete newItems[mappingId];
          return newItems;
        });
        refreshCart();
        window.scrollTo({ top: 0 });
      } else {
        console.error("Failed to update:", result.message);
      }
    } catch (error) {
      console.error("Error updating catering cart:", error);
    }
  };

  let categoryImage = null;

  outerLoop: for (const provider of data || []) {
    if (Array.isArray(provider.services)) {
      for (const service of provider.services) {
        if (service.category) {
          const isVeg = true;
          // const isVeg = service.category.toLowerCase() === "vegetarian";
          categoryImage = isVeg ? veglabel : nonveglabel;
          break outerLoop;
        }
      }
    }
  }

  // Add this function after your other helper functions
  const addGST = (amount) => {

    return Math.round(amount + gst_amount);
  };
  const cartItems = data?.[0]?.services?.map((svc) => {
    const validUpto = new Date(svc.validUpto);
    const date = new Date();
    const hasDiscount = svc.discountPrice > 0 && validUpto > date;
    const unitPrice = hasDiscount ? svc.discountPrice : svc.price;

    const total = svc.quantity * unitPrice;

    return {
      mapping_id: svc.mapping_id,
      quantity: svc.quantity,
      service_id: svc.service_id,
      price: unitPrice,
      total,
    };
  }) || [];


  const grandTotal = (cartItems.length > 0 ?
    cartItems[0].total :
    0);

  const cateringgrandtotal = balance_to_be_paid && balance_to_be_paid > 0
    ? addGST(balance_to_be_paid)
    : addGST(grandTotal)
  // console.log("cateringtotal",grandTotal,cateringgrandtotal)  
  return (
    <div className={styles.cartItemWrapper}>


      {data.flatMap((provider) =>
        provider.services.map((service, index) => {
          const mappingId = service.mapping_id;
          const isEditing = editingServices[mappingId];
          const quantity = editedItems[mappingId]?.number_of_people ?? service.quantity;
          const validUpto = new Date(service.validUpto)
          const date = new Date();
          const hasDiscount = service.discountPrice > 0 && validUpto > date;
          const discountedPrice = service.discountPrice ? service.discountPrice : 0
          const unitPrice = hasDiscount ? service.discountPrice : service.price;

          const total = (quantity * unitPrice);
          // console.log("catering",unitPrice,hasDiscount,total)
          const basetotal = addGST(quantity * unitPrice)
          const meal = service.mealtype;
          const cuisine = service.cuisine;

          return (
            <div key={`${provider.provider_id}-${mappingId}`} className={styles.cartItem}>
              <div className={styles.carttop}>
                <span style={{ marginTop: "0px", fontSize: "24px", fontWeight: "600" }}>Catering
                  {/* <input
      type="checkbox"
      checked={!!selectedcartitem.find((p)=>p.eventId===eventId)?.
        services["catering"].some(
        (pd) => pd.id === data[0].provider_id
      )
      }
      onChange={(e)=>{oncateringSelect(
        eventId,"catering",e.target.checked,{
          id:data?.[0].provider_id,
          cartid:data?.[0].services.map((svc)=>({
            mapping_id:svc.mapping_id,
            quantity:svc.quantity,
            service_id:svc.service_id,                        
          })),
          total:grandTotal,
        }
        
      )}}
      /> */}
                  <span style={{ marginLeft: "8px", fontSize: "24px" }} className={styles.regularPrice}>
                    {hasDiscount ? (
                      <>
                        <s>₹{service.quantity * service.price}</s> ₹{total}
                      </>
                    ) : (
                      `₹${total}`
                    )}
                  </span>
                </span>

              </div>
              <div className={styles.cartBodyInner}>

                <div className={styles.cartData}>
                  <div className={styles.middlerow}>
                    <div className={styles.cartName}>
                      {(provider.providername || "Catering Provider").replace(/\s+null$/i, "")}

                    </div>

                  </div>




                </div>
                <div className={styles.menulists}>
                  <div className={styles.menuitem}>
                    <div className={styles.menuitemcenter}>
                      <span className={styles.dot}>
                        <img src={breakfasticon} />  <span className={styles.selecteditem}>Meal:
                          <span className={styles.selecteditemname}>{meal}</span></span>

                      </span>

                      <span className={styles.dot}>
                        {categoryImage && (
                          <img src={categoryImage} alt="Category Icon" className={styles.categoryIcon} />
                        )}
                        <span className={styles.selecteditem}>Cuisine:
                          <span className={styles.selecteditemname}> {cuisine}</span></span>
                      </span>

                    </div>
                  </div>
                  <div className={styles.servicesList}>
                    <div className={styles.serviceRow}>
                      {isEditing ? (
                        <input
                          type="number"
                          min="0"
                          value={quantity}
                          onChange={(e) =>
                            handleCountChange(mappingId, e.target.value, provider.provider_id)
                          }
                          className={styles.itemCount}
                        />
                      ) : (
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                          <span className={styles.quantityText}>
                            {service.quantity}
                          </span>
                          <span>Guest From RSVP</span>
                        </div>
                      )}
                      {hasDiscount ? (
                        <span className={styles.price}>
                          <s>₹{service.price}</s> ₹{service.discountPrice} Per Plate
                        </span>
                      ) : (
                        <span className={styles.price}>₹{service.price} Per Plate</span>
                      )}


                    </div>
                  </div>
                </div>
                {(is_edit_allowed && !is_canceled) && <div>
                  <div className={styles.leftButtons}>
                    <div className={styles.cateringedit}>
                      <i style={{ color: "#26B8E3" }} className="pi pi-pencil"></i>
                      {!isEditing ? (
                        <button
                          className={styles.editBtn}
                          onClick={() =>
                            handleEditClick(mappingId, {
                              ...service,
                              provider_id: provider.provider_id,
                            })
                          }
                        >
                          Edit items

                        </button>
                      ) : (
                        <button
                          className={styles.saveBtn}
                          onClick={() => handleSave(provider.provider_id, mappingId)}
                        >
                          Save
                        </button>
                      )}
                    </div>
                    <div className={styles.cateringdelete} onClick={() => handleRemove(provider.provider_id, mappingId)}>
                      <img style={{ display: "flex", width: "16px", height: "18px", justifyContent: "center", marginRight: "6px" }} src={trashicon}
                        alt="trashicon" />
                      <button
                        className={styles.removeBtn}
                        onClick={() => handleRemove(provider.provider_id, mappingId)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
                }
                {/* cancel payment */}
                {(paid_amount > 0) &&
                  <div className={styles.deletepayment} onClick={() => setshowdeleteoverlay(true)}>
                    <i className="pi pi-times" style={{ color: 'red' }}></i>
                    <button
                      className={styles.removeBtn}
                      onClick={() => {
                        setshowdeleteoverlay(true)
                        console.log("clicked delete", eventId, data[0].provider_id)
                      }

                      }
                    >
                      Cancel payment
                    </button>
                  </div>
                }
              </div>
              <div className={styles.bottomdata}>
                {/* <div className={styles.cateringoptionsdata}>
                  <div className={styles.optionheader}>
                    <h3>Pay In Advance</h3>
                  </div>
                  <div className={styles.options}>
                    <label className={styles.priceoptions}>
                      <input
                        type="radio"
                        name={`payment-catering-${eventId}`}
                        checked={
                          !!selectedcartitem
                            .find((p) => p.eventid === eventId)
                            ?.services["catering"]?.some(
                              (pd) => pd.id === data[0].provider_id && pd.total === cateringgrandtotal
                            )
                        }
                        onClick={(e) => {
                          const isSelected =
                            selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["catering"]?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === cateringgrandtotal
                              ) || false;

                          if (isSelected) {
                            // 🔹 Unselect (toggle off)
                            oncateringSelect(eventId, "catering", false, {
                              id: data[0].provider_id,
                              cartid: [],
                              total: 0,
                            });
                            e.preventDefault(); // keep radio unchecked
                          }
                        }}
                        onChange={(e) => {
                          oncateringSelect(eventId, "catering", e.target.checked, {
                            id: data?.[0].provider_id,
                            cartid: data?.[0].services.map((svc) => ({
                              mapping_id: svc.mapping_id,
                              quantity: svc.quantity,
                              service_id: svc.service_id,
                            })),
                            total: cateringgrandtotal,
                          });
                        }}
                      />
                      Total Amount
                    </label>

                    <label className={styles.priceoptions}>
                      <input
                        type="radio"
                        name={`payment-catering-${eventId}`}
                        checked={
                          !!selectedcartitem
                            .find((p) => p.eventid === eventId)
                            ?.services["catering"]?.some(
                              (pd) =>
                                pd.id === data[0].provider_id && pd.total === cateringgrandtotal * 0.5
                            )
                        }
                        onClick={(e) => {
                          const isSelected =
                            selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["catering"]?.some(
                                (pd) =>
                                  pd.id === data[0].provider_id && pd.total === cateringgrandtotal * 0.5
                              ) || false;

                          if (isSelected) {
                            oncateringSelect(eventId, "catering", false, {
                              id: data[0].provider_id,
                              cartid: [],
                              total: 0,
                            });
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          oncateringSelect(eventId, "catering", e.target.checked, {
                            id: data?.[0].provider_id,
                            cartid: data?.[0].services.map((svc) => ({
                              mapping_id: svc.mapping_id,
                              quantity: svc.quantity,
                              service_id: svc.service_id,
                            })),
                            total: cateringgrandtotal * 0.5,
                          });
                        }}
                      />
                      50%
                    </label>

                    <label className={styles.priceoptions}>
                      <input
                        type="radio"
                        name={`payment-catering-${eventId}`}
                        checked={
                          !!selectedcartitem
                            .find((p) => p.eventid === eventId)
                            ?.services["catering"]?.some(
                              (pd) =>
                                pd.id === data[0].provider_id && pd.total === cateringgrandtotal * 0.25
                            )
                        }
                        onClick={(e) => {
                          const isSelected =
                            selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["catering"]?.some(
                                (pd) =>
                                  pd.id === data[0].provider_id && pd.total === cateringgrandtotal * 0.25
                              ) || false;

                          if (isSelected) {
                            oncateringSelect(eventId, "catering", false, {
                              id: data[0].provider_id,
                              cartid: [],
                              total: 0,
                            });
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          oncateringSelect(eventId, "catering", e.target.checked, {
                            id: data?.[0].provider_id,
                            cartid: data?.[0].services.map((svc) => ({
                              mapping_id: svc.mapping_id,
                              quantity: svc.quantity,
                              service_id: svc.service_id,
                            })),
                            total: cateringgrandtotal * 0.25,
                          });
                        }}
                      />
                      25%
                    </label>
                  </div>


                </div> */}





                <div className={styles.priceDetails}>
                  <div className={styles.priceDetails}>
                    <span className={styles.priceLabel}>Total: <span style={{ fontWeight: "600" }}>₹{service.final_price}</span> </span>
                    <span className={styles.priceLabel} style={{ color: "#666" }}>Taxes: <span style={{ fontWeight: "600", color: "#666" }}>₹{service.gst_amount}</span> </span>

                    <div style={{ borderTop: "1px solid #ddd", borderBottom: "1px solid #ddd", padding: "8px 0", margin: "8px 0" }}>
                      <span className={styles.priceLabel}>Sub Total: <span style={{ fontWeight: "600" }}>₹{service.total_amount}</span> </span>
                    </div>
                  </div>

                  <div style={{ marginTop: "16px" }}>
                    <span className={styles.priceLabel}>Paid Amount: <span style={{ fontWeight: "600" }}>₹{paid_amount}</span> </span>
                  </div>

                  <span className={styles.regularPrice}>
                    <span>Balance to be paid:</span>
                    {!isNaN(balance_to_be_paid) && balance_to_be_paid > 0 ? (
                      <>
                        <span style={{ fontWeight: "600" }}>₹{balance_to_be_paid}</span>
                      </>
                    ) : (
                      <>
                        <span style={{ fontWeight: "600" }}>₹{service.total_amount}</span>
                      </>
                    )}
                  </span>

                  <div>
                    {selectedAmount && (
                      <div>
                        {/* <p style={{ fontWeight: "bold", marginTop: "10px" }}>
          To Pay<s>₹{service.quantity * service.price}</s>
          ₹{selectedAmount} <span style={{ fontSize: "14px", color: "#666" }}>(incl. GST) %</span>
        </p> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
      {/* cancel dialog */}
      <Dialog
        visible={showdeleteoverlay}
        onHide={() => setshowdeleteoverlay(false)}
        header="Confirm Delete"
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setshowdeleteoverlay(false)}
              className="p-button-text"
            />
            <Button
              label="Delete"
              icon="pi pi-check"
              severity="danger"
              onClick={deletepaidamount}
              autoFocus
            />
          </div>
        }
      >
        <span>Are you sure you want to delete the paid tent Provider?</span>
      </Dialog>

      <Dialog
        visible={showcancelationconfirmation}
        onHide={() => setshowcancelationconfirmation(false)}
        header="Confirm Delete"
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Okay"
              icon="pi pi-times"
              onClick={() => setshowcancelationconfirmation(false)}
              className="p-button-text"
            />

          </div>
        }
      >
        <span>You will get your amount back in some days</span>
      </Dialog>
      <ShowDialogForPayment
        refundItems={["catering"]}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
      />
    </div>
  );
};

export default CateringCartItemCard;
